import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { AnalyticsLoaderService } from './core/services/analytics-loader.service';
import { AuthService } from './core/services/auth.service';
import { DesignService } from './core/services/design.service';
import { GeolocationBlockerService } from './core/services/geolocation-blocker.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'CitizeX';

  headerStyle: string;
  headerStyleSubscription: any;

  // loggedInUser used to get cookie details
  private loggedInUser: any;
  public showSideBar = false;
  public isLandingPage = false;
  public isIdentityVerificationHandoff = false;

  public getUserLoggedIn(): string {
    return this.authService.getLogflag();
  }

  constructor(
    private authService: AuthService,
    private cookieService: CookieService,
    private router: Router,
    private designService: DesignService,
    private geolocationBlockerService: GeolocationBlockerService,
    private analyticsLoaderService: AnalyticsLoaderService,
    private cdr: ChangeDetectorRef
  ) {
    this.headerStyle = designService.headerStyle;
    this.headerStyleSubscription =
      this.designService.headerStyleChange.subscribe((value) => {
        this.headerStyle = value;
      });

    // If user is already logged in (now shared via localStorage across tabs)
    // only redirect away from root or landing page if needed
    if (this.authService.getLogflag()) {
      const user = this.authService.getUser();
      const currentPath = window.location.pathname;
      if ((currentPath === '/' || currentPath === '/landing-page') && user) {
        if (!user.isTourDone && user.defaultProfileTagName) {
          this.router.navigateByUrl(
            '/profile/view-profile/' + user.defaultProfileTagName,
            { replaceUrl: true }
          );
        } else {
          this.router.navigateByUrl('/homepage', { replaceUrl: true });
        }
      }
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateRouteLayout(event.urlAfterRedirects || event.url);
      }
    });
    this.updateRouteLayout(this.router.url, false);

    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     this.clearModals();
    //   }
    // });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // delay cleanup so Bootstrap animations don't conflict
        setTimeout(() => {
          this.clearModals();
        }, 0);
      }
    });
  }

  private clearModals(): void {
    // Remove backdrops
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());

    // Reset body state
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('padding-right');

    // Force-hide any stuck modals
    document.querySelectorAll('.modal').forEach((modal: any) => {
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
    });
  }

  ngOnInit(): void {
    this.analyticsLoaderService.init();

    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.style.transition = 'opacity 0.3s ease';
      loader.style.opacity = '0';
      setTimeout(() => (loader.style.display = 'none'), 300);
    }
  }

  private updateRouteLayout(url: string, detectChanges = true): void {
    const path = url.split(/[?#]/, 1)[0];
    this.isLandingPage =
      path === '/' ||
      path === '/landing-page' ||
      path.startsWith('/landing-page/');
    this.isIdentityVerificationHandoff =
      path === '/identity-verification/complete';
    if (detectChanges) {
      this.cdr.detectChanges();
    }
  }
}
